// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Suspense, useEffect, useMemo} from 'react';
import {perr_www_visit, pathname_to_perr_id} from 'hola_pub_util';
import {Content, i_element} from '../../../../hola/pub/lib/content';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {Splash_screen_loader} from
    '../../../../toolip/pub/ui/splash_screen_loader/splash_screen_loader';

export const Root = ()=>{
    const {pathname} = use_pathname();
    useEffect(()=>{
        perr_www_visit({id: `oculus_${pathname_to_perr_id(pathname)}_visit`});
    }, []);
    const elements = useMemo<i_element[]>(()=>{
        return [];
    }, []);
    return <div>
      <Suspense fallback={<Splash_screen_loader show no_transition/>}>
        <Content elements={elements}/>
      </Suspense>
    </div>;
};

Root.meta = {
    no_ssr: false,
};
